/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import React, { useState } from 'react';
import { joinDataTestId, Label } from '@motili/ui';
import styled from 'styled-components';
import { Collapse } from '@mui/material';
import { Clickable } from './ribbon/document-ribbon/components/Clickable';
import { RibbonItemContainer } from './ribbon/document-ribbon/components/RibbonItemContainer';
import { ExpandLessIcon } from './ribbon/document-ribbon/components/ExpandLessIcon';
import { ExpandMoreIcon } from './ribbon/document-ribbon/components/ExpandMoreIcon';

const Wrapper = styled.div`
    padding-left: 15px;
`;

interface ExpandableLabelProps {
    label?: string;
    dataTestId?: string;
    children?: React.ReactNode;
    defaultExpanded?: boolean;
}

export const ExpandableLabel = (props: ExpandableLabelProps) => {
    const { label, dataTestId, children, defaultExpanded = false } = props;
    const [isExpanded, setIsExpanded] = useState<boolean>(defaultExpanded);

    return (
        <div data-test-id={dataTestId}>
            <Wrapper>
                <Clickable
                    data-test-id={joinDataTestId([dataTestId, 'toggle-button'])}
                    onClick={() => setIsExpanded(prev => !prev)}
                >
                    <RibbonItemContainer>
                        {isExpanded ? (
                            <ExpandMoreIcon className='expand-toggle' />
                        ) : (
                            <ExpandLessIcon className='expand-toggle' />
                        )}
                        {label && (
                            <Label label={label} style={{ paddingTop: 5 }} />
                        )}
                    </RibbonItemContainer>
                </Clickable>
            </Wrapper>

            <Collapse in={isExpanded} orientation='vertical' unmountOnExit>
                <div style={{ paddingLeft: '16px', marginTop: '8px' }}>
                    {children}
                </div>
            </Collapse>
        </div>
    );
};
